import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "./apiAuth";
import {
  authHeader,
  userEmail,
  canonicalizeResponse,
} from './common';
import { notification } from "antd";

/* =======================
   ASYNC THUNKS
======================= */

// Withdraw Request
export const withdrawRequest = createAsyncThunk(
  "passbook/withdrawRequest",
  async (payload, { rejectWithValue }) => {
    try {
      payload.email = await userEmail();
      const response = await api.post(
        "/withdrawals",
        payload,
        { headers: await authHeader() }
      );
      return canonicalizeResponse(response);
    } catch (error) {
      notification.error({ message: error.message });
      return rejectWithValue(error.message);
    }
  }
);

// Withdraw List
export const withdrawList = createAsyncThunk(
  "passbook/withdrawList",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.get(
        "/withdrawals",
        { headers: await authHeader(), params: payload }
      );
      return canonicalizeResponse(response);
    } catch (error) {
      notification.error({ message: error.message });
      return rejectWithValue(error.message);
    }
  }
);

// Earning List
export const earningList = createAsyncThunk(
  "passbook/earningList",
  async (payload, { rejectWithValue }) => {
   
    try { 
      const response = await api.get(
        "/earnings",
        { headers: await authHeader(), params: payload }
      );
      return canonicalizeResponse(response);
    } catch (error) {
      notification.error({ message: error.message });
      return rejectWithValue(error.message);
    }
  }
);
export const allEarningList = createAsyncThunk(
  "passbook/allEarningList",
  async (_, { rejectWithValue }) => {
    try { 
      const response = await api.get(
        "/earnings",
        { headers: await authHeader() }
      );
      return canonicalizeResponse(response);
    } catch (error) {
      notification.error({ message: error.message });
      return rejectWithValue(error.message);
    }
  }
);

/* =======================
   INITIAL STATE
======================= */

const initialState = {
  withdrawRequestData: null,
  withdrawListData: [],
  earningListData: [],
  allEarningListData: [],
  loading: false,
  error: null,
};

/* =======================
   SLICE
======================= */

const passbookSlice = createSlice({
  name: "passbook",
  initialState,
  reducers: {
    clearPassbookState: (state) => {
      state.withdrawRequestData = null;
      state.withdrawListData = [];
      state.earningListData = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder

      // Withdraw Request
      .addCase(withdrawRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(withdrawRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.withdrawRequestData = action.payload;
      })
      .addCase(withdrawRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Withdraw List
      .addCase(withdrawList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(withdrawList.fulfilled, (state, action) => {
        state.loading = false;
        state.withdrawListData = action.payload;
      })
      .addCase(withdrawList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Earning List
      .addCase(earningList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(earningList.fulfilled, (state, action) => {
        state.loading = false;
        state.earningListData = action.payload;
      })
      .addCase(earningList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // All Earning List;
      .addCase(allEarningList.pending, (state) => {
        state.loading = true;
      })
      .addCase(allEarningList.fulfilled, (state, action) => {
        state.loading = false;
        state.allEarningListData = action.payload;
      })
      .addCase(allEarningList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearPassbookState } = passbookSlice.actions;
export default passbookSlice.reducer;
